import { render, staticRenderFns } from "./SimpleCompanySearch.vue?vue&type=template&id=0fed540e&scoped=true&"
import script from "./SimpleCompanySearch.vue?vue&type=script&lang=ts&"
export * from "./SimpleCompanySearch.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCompanySearch.vue?vue&type=style&index=0&id=0fed540e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed540e",
  null
  
)

export default component.exports